import { RailCard } from './rail-card'
import { SelectedImpactDetails } from './selected-impact-details'
import type { ImpactRow } from './types'

/** 선택한 영향 항목의 원문, 기존 답변, 현재 점수, 변경 영향을 표시한다. */
export function SelectedImpactCard({
    selectedImpact,
}: {
    selectedImpact: ImpactRow | null
}) {
    return (
        <RailCard title='선택 항목 상세'>
            {selectedImpact ? (
                <SelectedImpactDetails selectedImpact={selectedImpact} />
            ) : (
                <p className='text-muted-foreground text-sm'>
                    영향 항목을 선택하면 체크리스트 원문, 기존 답변, 현재 점수를
                    확인할 수 있습니다.
                </p>
            )}
        </RailCard>
    )
}
